import moment from "moment";
import Cookies from "js-cookie";
import styled from "styled-components";
import DatePicker, { registerLocale } from "react-datepicker";
import "./DatePickerCSS.css";
import { useDispatch, useSelector } from "react-redux";
import * as Actions from "../../store/actions/cases/allCasesActions";
import * as dateFormat from "../../util/dateUtils";
import { dateConversion } from "../../util/dateUtils";
import nl from "date-fns/locale/nl";
import de from "date-fns/locale/de";
import fr from "date-fns/locale/fr";
import en from "date-fns/locale/en-US";
import { useState, useEffect } from "react";
import PropTypes from "prop-types";
registerLocale("nl", nl);
registerLocale("de", de);
registerLocale("fr", fr);
registerLocale("en", en);

const DateFilterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: ${(props) => (props.marginLeft ? props.marginLeft : "")};
  @media (max-width: 767px) {
    width: 100%;
  }

  & label {
    font-weight: bold;
    font-family: neue-haas-grotesk-text;
    color: #000000;
    font-size: 0.75rem;
  }
  & input {
    border-radius: 4px;
    border: 1px solid #d8dada;
    font-size: 0.625rem;
    margin-top: ${(props) => (props.marginTop ? props.marginTop : "0.5rem")};
    margin-right: ${(props) => (props.marginRight ? props.marginRight : "1rem")};
    height: 2.75rem;
    width: 11.25rem;
    // padding-left: 1rem;
    padding: 12px 16px 12px 16px;
    font-family: neue-haas-grotesk-text;
    @media (max-width: 767px) {
      width: ${(props) => (props.inputWidth ? props.inputWidth : "")};
    }
    @media (min-width: 768px) {
      // width: 11.25rem;
      width: 12.68rem;
    }
  }
`;

function DateFilter({
  labelText,
  date,
  handleDateFilter,
  placeHolder,
  DateFlag,
  ariaLabelledby,
  ariaDescribedby,
  style,
  inputWidth,
  marginTop,
  marginRight,
}) {
  const [regionDataFormat, setRegionDataFormat] = useState("MM/dd/yyyy");
  const regionId = useSelector((state) => state.ACCOUNT.regionId);
  const dateFormat = useSelector((state) => state.CASELIST.dateFormat);
  const dispatch = useDispatch();

  // Parse date string according to the specified format
  const parseDate = (dateString) => {
    if (!dateString) return null;
    if (dateFormat) {
      // Use moment to parse the date string according to the format
      const parsedMoment = moment(dateString, dateFormat.toUpperCase(), true);
      if (parsedMoment.isValid()) {
        return parsedMoment.toDate();
      }
    }
    // Fallback to new Date() if moment parsing fails
    return new Date(dateString);
  };

  useEffect(() => {
    if (regionId) {
      setRegionDataFormat(getDateFormat(regionId));
    }
  }, [regionId]);

  const getDateFormat = (regionId) => {
    switch (regionId) {
      case "36":
      case "554":
        return "dd/MM/yyyy";
      case "372":
      case "250":
      case "276":
      case "528":
      case "826":
      case "40":
      case "56":
        return "dd.MM.yyyy";
      case "840":
      case "124":
        return "MM/dd/yyyy";
      default:
        return "MM/dd/yyyy";
    }
  };

  const handleOnDateSelect = (value) => {
    if (DateFlag === "From") {
      dispatch(Actions.setFromDate(dateConversion(value, dateFormat?.toUpperCase())));
    } else if (DateFlag === "To") {
      dispatch(Actions.setToDate(dateConversion(new Date(value))));
    }
  };

  return (
    <DateFilterWrapper
      role="search"
      aria-label="Date Search"
      marginLeft={style.marginLeft}
      inputWidth={inputWidth}
      marginTop={marginTop}
      marginRight={marginRight}
    >
      <label htmlFor="date input">{labelText}</label>
      {/* <input
        type="date"
        id="date input"
        aria-label={labelText}
        onChange={handleDateFilter}
        value={date}
        max={new Date().toISOString().slice(0, 10)}
      ></input> */}
      <DatePicker
        id="date input"
        className="datePickerInput"
        autoComplete="off"
        ariaLabelledBy={ariaLabelledby}
        ariaDescribedBy={ariaDescribedby}
        selected={parseDate(date)}
        onChange={handleDateFilter}
        maxDate={new Date()}
        placeholderText={placeHolder}
        closeOnScroll={true}
        peekNextMonth
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        showPopperArrow={false}
        onSelect={handleOnDateSelect}
        dateFormat={regionDataFormat}
        locale={Cookies.get("userLanguage") ? Cookies.get("userLanguage").split("-")[0] : "en"}
      ></DatePicker>
    </DateFilterWrapper>
  );
}

DateFilter.defaultProps = {
  date: null,
  placeHolder: "mm/dd/yyyy",
  DateFlag: "",
  style: {},
  inputWidth: "",
  marginTop: "",
};

DateFilter.propTypes = {
  labelText: PropTypes.string.isRequired,
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  handleDateFilter: PropTypes.func,
  placeHolder: PropTypes.string,
  DateFlag: PropTypes.string,
  ariaLabelledby: PropTypes.string,
  ariaDescribedby: PropTypes.string,
  style: PropTypes.object,
  inputWidth: PropTypes.string,
  marginTop: PropTypes.string,
  marginRight: PropTypes.string,
};

export default DateFilter;
